/*
 * 评论相关的全局交互
 */

(function($) {

  $(function() {
    // del and edit comment
    $(document)
      .on('click', '.comment-actions .more', function(e) {
        var $target = $(e.currentTarget).addClass('active');
        var $panel = $($target.closest('.comment').find('.tpl-comment-actions-menu').html());

        var popover = simple.popover({
          pointTo: $target,
          content: $panel,
          position: 'bottom-left',
          cls: 'popover-comment-actions-menu popover-actions-menu no-arrow',
          autohide: false,
          offset: {
            x: 0,
            y: -10
          }
        });

        popover.one('popover:destroy', function() {
          $target.removeClass('active');
        });

        $(document).on('click', '.wrapper', function() {
          if (popover) popover.destroy();
        });
      }).on('ajax:success', '.popover-comment-actions-menu .del', delCommentSuccess)
      .on('click', '.popover-comment-actions-menu .show-notify-members:not([data-remote])', toggleCommentNotifyMembers)
      .on('ajax:success', '.popover-comment-actions-menu .show-notify-members', showCommentNotifyMembers)
  });

  function delCommentSuccess(e, result) {
    var popover = $(e.target).closest('.simple-popover').data('popover');
    if (!popover) return;
    var $target = popover.pointTo;

    popover.destroy();
    $target.closest('.comment').fadeOut(function() {
      $(this).remove();
    });

    if (result.todo_html) {
      tower.todoSubject.next('update', {
        id: result.commentable_id,
        html: result.todo_html,
      });
    }
  }

  function toggleCommentNotifyMembers(e) {
    var popover = $(e.target).closest('.simple-popover').data('popover');
    if (!popover) return;
    var $comment = popover.pointTo.closest('.comment');

    popover.destroy();
    $comment.find('.comment-notify-members').toggle();
  }

  function showCommentNotifyMembers(e, result) {
    var popover = $(e.target).closest('.simple-popover').data('popover');
    if (!popover) return;
    var $comment = popover.pointTo.closest('.comment');

    popover.destroy();
    $comment.find('.tpl-comment-actions-menu .show-notify-members')
      .attr('href', 'javascript:;')
      .removeAttr('data-remote');

    var $members = $comment.find('.comment-notify-members');
    if ($members.length) {
      $members.replaceWith($(result.html))
    } else {
      $comment.find('.comment-main .info').after($(result.html))
    }
  }

  $.extend(tower, {

    adjustAuthor: function() {
      var jFrm = $('.comment-form, .form-new-discussion');
      jFrm.find('.avatar-wrap').attr('href', '/members/' + tower.me.guid);
      jFrm.find('img.avatar').attr('src', tower.me.avatar);
    },

    adjustCommentEvents: function() {
      $('.streams .event-created-at').each(function(i, el) {
        var $el = $(el);
        var date = $el.data('created-at');
        if (!date) {
          return;
        }
        date = moment.tz(date, tower.me.tz);
        var now = tower.now();
        if (now.year() == date.year()) {
          $el.text(date.format('MM-DD HH:mm'));
        } else {
          $el.text(date.format('YYYY-MM-DD HH:mm'));
        }
      });
    },

    foldComments: function() {
      var $commentEls = $('.comments.streams');
      var commentsNum = $commentEls.find('>.comment').length;

      if (commentsNum > 20) {
        var $anchor = $(location.hash);
        var $hiddenEls = $commentEls.find('>.comment').eq(commentsNum - 10).prevAll();

        if ($anchor.length && $hiddenEls.filter($anchor).length) {
          return false;
        }

        var $foldEl = $(simple.tpl($("#tpl-fold-comment").html(), {
          comments_num: commentsNum - 10
        })).prependTo($commentEls);
        $hiddenEls.hide();

        $foldEl.find('.link-fold-comment').on('click', function(e) {
          e.preventDefault();
          $foldEl.remove();
          $hiddenEls.show();
        });
      }
    },

    refreshCCGroup: function($notify) {
      if (!$notify) {
        $notify = $('.notify');
      }

      var $groups = $notify.find('.group-select').removeClass('selected');
      var $members = $notify.find('.member-list input:checkbox');

      if ($members.filter(':not(:checked)').length === 0) {
        $groups.addClass('selected');
      } else {
        $groups.each(function(i, group) {
          var $group = $(group);
          var groupId = $group.data('subgroup');
          var $selected = $members.filter('[data-subgroup*=' + groupId + ']');
          if ($selected.length > 0 && $selected.filter(':not(:checked)').length === 0) {
            $group.addClass('selected');
          }
        });
      }
    },

    adjustCommentsLike: function() {
      var text = $('#comments-liked-list').text().trim();
      if (!text.length) {
        return false;
      }

      var list = text.split(',');
      var $comments = $('.comments');

      list.forEach(function(guid) {
        var $link = $comments.find('.comment#' + guid + ' .comment-actions .like');
        var url = $link.attr('href').replace('/like', '/unlike');

        $link.attr('href', url).addClass('i-liked');
      });
    }
  });

})(jQuery);
